module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated zoomIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "noPadding"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discoLogo),
      expression: "discoLogo"
    }],
    attrs: {
      "id": "discoTitle"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 text-center",
    attrs: {
      "id": "noPadding"
    }
  }, [_c('svg', {
    attrs: {
      "id": "svgTitle",
      "viewBox": "0 0 1200 200"
    }
  }, [_c('symbol', {
    attrs: {
      "id": "s-text"
    }
  }, [_c('text', {
    attrs: {
      "text-anchor": "middle",
      "x": "600",
      "y": "50",
      "dy": ".65em"
    }
  }, [_vm._v("\n\t\t\t\t\t\t    " + _vm._s(_vm.FutureFit) + "\n\t\t\t\t\t\t    ")])]), _vm._v(" "), _c('use', {
    staticClass: "text",
    attrs: {
      "xlink:href": "#s-text"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "text",
    attrs: {
      "xlink:href": "#s-text"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "text",
    attrs: {
      "xlink:href": "#s-text"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "text",
    attrs: {
      "xlink:href": "#s-text"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "text",
    attrs: {
      "xlink:href": "#s-text"
    }
  })])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated zoomIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHelp),
      expression: "showHelp"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "noPadding"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "mattMcCorkle"
    }
  }, [_c('strong', [_vm._v(" Created by: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("Matt McCorkle")])]), _vm._v("\n  \t\t\t\t\t@\n  \t\t\t\t\t"), _c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "https://www.newinc.org",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("NEW INC")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "mattMcCorkle"
    }
  }, [_c('strong', [_vm._v(" Music by: ")]), _vm._v(" "), _c('br'), _vm._v("\n  \t\t\t\t\t\"The Skeleton Rag\" \n\t\t\t\t\t"), _c('br'), _vm._v("\n  \t\t\t\t\tfrom \n  \t\t\t\t\t"), _c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "http://www.samreidermusic.com/",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("\n  \t\t\t\t\tSam Reider's")])]), _vm._v(" "), _c('br'), _vm._v("\n  \t\t\t\t\tupcoming recording \n  \t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" \"Too Hot To Sleep\" ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "shoutOutPullDown"
    }
  }, [_c('p', {
    attrs: {
      "id": "shoutOuts"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "https://tonejs.github.io/",
      "target": "_blank"
    }
  }, [_vm._v("Special thanks to "), _c('u', [_vm._v("Tone.js")]), _vm._v(" by Yotam Mann")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "mattMcCorkle"
    }
  }, [_vm._v(" Stay in touch for new project releases! \n\t\t\t\t"), _c('br')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "https://space.us12.list-manage.com/subscribe/post?u=cc407290614bbaa2daa32fe9e&id=219d3ce36c",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "mc_embed_signup_scroll"
    }
  }, [_c('input', {
    staticClass: "email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "email address",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_cc407290614bbaa2daa32fe9e_219d3ce36c",
      "tabindex": "-1",
      "value": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "submit",
      "value": "Subscribe!",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-blackwhiteneg",
    attrs: {
      "id": "helpBtnHome"
    },
    on: {
      "click": _vm.goToHome
    }
  }, [_c('strong', [_vm._v(" Now Take Me Back! ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated zoomIn",
      "leave-active-class": "animated zoomOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSection),
      expression: "showSection"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "noPadding"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-offset-0",
    attrs: {
      "id": "Section1PullUp"
    }
  }, [_c('p', {
    attrs: {
      "id": "Section1TitleText"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.LoadingText1) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience1Func
    }
  }, [_c('i', {
    class: _vm.ambience1Icon,
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFierce Storm\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol"
    }],
    staticClass: "dangerRanger",
    attrs: {
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "5",
      "min": "-30",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "ambienceBadges"
    }
  }, [_vm._v("Volume " + _vm._s(_vm.ambience1Vol) + " dB")])]), _vm._v(" "), _c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience2Func
    }
  }, [_c('i', {
    class: _vm.ambience2Icon,
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tGraveyard\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol"
    }],
    staticClass: "dangerRanger",
    attrs: {
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "5",
      "min": "-20",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "ambienceBadges"
    }
  }, [_vm._v("Volume " + _vm._s(_vm.ambience2Vol) + " dB")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience3Func
    }
  }, [_c('i', {
    class: _vm.ambience3Icon,
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSewer\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol"
    }],
    staticClass: "dangerRanger",
    attrs: {
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "5",
      "min": "-20",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "ambienceBadges"
    }
  }, [_vm._v("Volume " + _vm._s(_vm.ambience3Vol) + " dB")])]), _vm._v(" "), _c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience4Func
    }
  }, [_c('i', {
    class: _vm.ambience4Icon,
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tLaboratory\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol"
    }],
    staticClass: "dangerRanger",
    attrs: {
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "5",
      "min": "-20",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "ambienceBadges"
    }
  }, [_vm._v("Volume " + _vm._s(_vm.ambience4Vol) + " dB")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "id": "Section2BodyText"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.LoadingText3) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    class: _vm.SFX1Class,
    attrs: {
      "id": "SFXBtnRepeat",
      "": _vm.musicVolume1
    },
    on: {
      "click": function($event) {
        _vm.SFX1Boolean = !_vm.SFX1Boolean
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAccordion\n\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    class: _vm.SFX2Class,
    attrs: {
      "id": "SFXBtnRepeat",
      "": _vm.musicVolume2
    },
    on: {
      "click": function($event) {
        _vm.SFX2Boolean = !_vm.SFX2Boolean
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tBass\n\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    class: _vm.SFX3Class,
    attrs: {
      "id": "SFXBtnRepeat",
      "": _vm.musicVolume3
    },
    on: {
      "click": function($event) {
        _vm.SFX3Boolean = !_vm.SFX3Boolean
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tSaxophone\n\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    class: _vm.SFX4Class,
    attrs: {
      "id": "SFXBtnRepeat",
      "": _vm.musicVolume4
    },
    on: {
      "click": function($event) {
        _vm.SFX4Boolean = !_vm.SFX4Boolean
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tMandolin\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    class: _vm.SFX5Class,
    attrs: {
      "id": "SFXBtnRepeat",
      "": _vm.musicVolume5
    },
    on: {
      "click": function($event) {
        _vm.SFX5Boolean = !_vm.SFX5Boolean
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tFiddle\n\t\t\t\t\t\t")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    class: _vm.SFX6Class,
    attrs: {
      "id": "SFXBtnRepeat",
      "": _vm.musicVolume6
    },
    on: {
      "click": function($event) {
        _vm.SFX6Boolean = !_vm.SFX6Boolean
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tGuitar\n\t\t\t\t\t\t")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('button', {
    class: _vm.destroyClass,
    attrs: {
      "id": "MusicNukeBtn",
      "": _vm.audioMixing
    },
    on: {
      "click": _vm.destroyFunc
    }
  }, [_c('i', {
    class: _vm.musicNukeIcon,
    style: ({
      'color': _vm.destroyIt ? _vm.stopColor : _vm.playColor
    })
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.SkeletonDance))]), _vm._v(" "), _c('i', {
    class: _vm.musicNukeIcon,
    style: ({
      'color': _vm.destroyIt ? _vm.stopColor : _vm.playColor
    })
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SFX1MODEL),
      expression: "SFX1MODEL"
    }],
    staticClass: "warningRanger",
    attrs: {
      "id": "SFXRepearSlider",
      "type": "range",
      "": _vm.audioMixing,
      "max": "2",
      "min": ".1",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.SFX1MODEL)
    },
    on: {
      "__r": function($event) {
        _vm.SFX1MODEL = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "SFXRepeatBadge"
    }
  }, [_vm._v("Music Speed " + _vm._s(_vm.SFX1MODEL) + "x ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sfxChorus),
      expression: "sfxChorus"
    }],
    staticClass: "warningRanger",
    attrs: {
      "id": "SFXRepearSlider",
      "type": "range",
      "": _vm.audioMixing,
      "max": "100",
      "min": "0",
      "step": "1"
    },
    domProps: {
      "value": (_vm.sfxChorus)
    },
    on: {
      "__r": function($event) {
        _vm.sfxChorus = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "SFXRepeatBadge"
    }
  }, [_vm._v("Music Chorus " + _vm._s(_vm.sfxChorus) + "% ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.musicReverb),
      expression: "musicReverb"
    }],
    staticClass: "warningRanger",
    attrs: {
      "id": "SFXRepearSlider",
      "type": "range",
      "": _vm.audioMixing,
      "max": "100",
      "min": "0",
      "step": "1"
    },
    domProps: {
      "value": (_vm.musicReverb)
    },
    on: {
      "__r": function($event) {
        _vm.musicReverb = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "SFXRepeatBadge"
    }
  }, [_vm._v("Music Reverb " + _vm._s(_vm.musicReverb) + "% ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.musicVol),
      expression: "musicVol"
    }],
    staticClass: "warningRanger",
    attrs: {
      "id": "SFXRepearSlider",
      "type": "range",
      "": _vm.audioMixing,
      "max": "5",
      "min": "-20",
      "step": "1"
    },
    domProps: {
      "value": (_vm.musicVol)
    },
    on: {
      "__r": function($event) {
        _vm.musicVol = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "SFXRepeatBadge"
    }
  }, [_vm._v("Music Volume " + _vm._s(_vm.musicVol) + "dB ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.musicFilter),
      expression: "musicFilter"
    }],
    staticClass: "warningRanger",
    attrs: {
      "id": "SFXRepearSlider",
      "type": "range",
      "": _vm.audioMixing,
      "max": "100",
      "min": "0",
      "step": "1"
    },
    domProps: {
      "value": (_vm.musicFilter)
    },
    on: {
      "__r": function($event) {
        _vm.musicFilter = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "SFXRepeatBadge"
    }
  }, [_vm._v("Music Warp " + _vm._s(_vm.musicFilter) + "% ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.musicDestroy),
      expression: "musicDestroy"
    }],
    staticClass: "warningRanger",
    attrs: {
      "id": "SFXRepearSlider",
      "type": "range",
      "": _vm.audioMixing,
      "max": "100",
      "min": "0",
      "step": "1"
    },
    domProps: {
      "value": (_vm.musicDestroy)
    },
    on: {
      "__r": function($event) {
        _vm.musicDestroy = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    attrs: {
      "id": "SFXRepeatBadge"
    }
  }, [_vm._v("Music Destroy " + _vm._s(_vm.musicDestroy) + "%")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "Evilizor"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.masterDistort),
      expression: "masterDistort"
    }],
    staticClass: "dangerRanger2",
    attrs: {
      "id": "evilSlider",
      "type": "range",
      "": _vm.audioMixing,
      "max": "100",
      "min": "0",
      "step": "1"
    },
    domProps: {
      "value": (_vm.masterDistort)
    },
    on: {
      "__r": function($event) {
        _vm.masterDistort = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    staticStyle: {
      "background-color": "red"
    },
    attrs: {
      "id": "audioBadge"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Sound Effect EVIL-IZOR " + _vm._s(_vm.masterDistort) + "% ")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "Section1BodyText"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.LoadingText2) + " ")])]), _vm._v(" "), _c('button', {
    class: _vm.SFX11Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX11
    }
  }, [_vm._v("\n\t\t\t\t\t \tLaugh\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX21Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX21
    }
  }, [_vm._v("\n\t\t\t\t\t\tGhost Whisper\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX25Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX25
    }
  }, [_vm._v("\n\t\t\t\t\t\tScreams\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX22Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX22
    }
  }, [_vm._v("\n\t\t\t\t\t\tInsect Swarm\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX9Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX9
    }
  }, [_vm._v("\n\t\t\t\t\t\tGouge\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX7Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX7
    }
  }, [_vm._v("\n\t\t\t\t\t\tZombie Growl\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX8Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX8
    }
  }, [_vm._v("\n\t\t\t\t\t\tAngry Zombie\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX12Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX12
    }
  }, [_vm._v("\n\t\t\t\t\t\tAngry Beast\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX10Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX10
    }
  }, [_vm._v("\n\t\t\t\t\t\tCrow\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX13Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX13
    }
  }, [_vm._v("\n\t\t\t\t\t\tChainsaw\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX14Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX14
    }
  }, [_vm._v("\n\t\t\t\t\t\tKnife\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX15Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX15
    }
  }, [_vm._v("\n\t\t\t\t\t\tMedical Saw\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX16Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX16
    }
  }, [_vm._v("\n\t\t\t\t\t\tTorch\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX23Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX23
    }
  }, [_vm._v("\n\t\t\t\t\t\tContraption\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX17Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX17
    }
  }, [_vm._v("\n\t\t\t\t\t\tWormhole\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX18Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX18
    }
  }, [_vm._v("\n\t\t\t\t\t\tDrama\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX19Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX19
    }
  }, [_vm._v("\n\t\t\t\t\t\tInterdimensional\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX20Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX20
    }
  }, [_vm._v("\n\t\t\t\t\t\tSaturn\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX24Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX24
    }
  }, [_vm._v("\n\t\t\t\t\t\tBio Suit\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.SFX26Class,
    attrs: {
      "id": "SFXBtn"
    },
    on: {
      "click": _vm.SFX26
    }
  }, [_vm._v("\n\t\t\t\t\t\tNeeds A Sub\n\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "Evilizor"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sfxVol),
      expression: "sfxVol"
    }],
    staticClass: "dangerRanger2",
    attrs: {
      "id": "evilSlider",
      "type": "range",
      "": _vm.audioMixing,
      "max": "5",
      "min": "-5",
      "step": "1"
    },
    domProps: {
      "value": (_vm.sfxVol)
    },
    on: {
      "__r": function($event) {
        _vm.sfxVol = $event.target.value
      }
    }
  }), _c('br'), _c('span', {
    staticClass: "badge",
    staticStyle: {
      "background-color": "red"
    },
    attrs: {
      "id": "audioBadge"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Horrible Sounds Volume " + _vm._s(_vm.sfxVol) + "dB ")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-blackwhiteneg",
    attrs: {
      "id": "helpBtn",
      "": _vm.audioMixing
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_vm._v(" Why Make Such A Thing? ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04ea2fb0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template.vue
// module id = 18
// module chunks = 0